import { useEffect, useState } from "react";
import { preloadImage } from "../../utils/image";
import { ContentPreview } from "./content-preview";

import type { Loadable } from "../../utils/jotai-loadable";
import type { MultiformatDimensions } from "../multiformat/store/types";
import type { PreviewEditHandler } from "./content-preview";
import type { FC } from "react";

export const ContentPreviewImage: FC<{
  image: Loadable<Promise<{ url: string; customTemplate: boolean } | null>>;
  onEdit: PreviewEditHandler;
  onApplyToAll?: PreviewEditHandler;
  hidden: boolean;
  designer: string | null;
  dimensions: MultiformatDimensions;
  contentTypeName: string;
  onLoaded?: () => void;
}> = ({ image, onEdit, hidden, designer, dimensions, onApplyToAll, contentTypeName, onLoaded }) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (image.state === "loading") {
      setImageUrl(undefined);
    }

    if (image.state === "hasData" && image.data?.url) {
      preloadImage(image.data?.url)
        .then(() => setImageUrl(image.data?.url ?? undefined))
        .catch(() => {
          console.log("Image preview failed");
        });
    }
  }, [image]);

  if (image.state === "hasError") {
    return null;
  }

  return (
    <ContentPreview
      image={image}
      onEdit={onEdit}
      onApplyToAll={onApplyToAll}
      hidden={hidden}
      designer={designer}
      imageUrl={imageUrl}
      dimensions={dimensions}
      contentTypeName={contentTypeName}
      onLoaded={onLoaded}
    />
  );
};
